const mockEmployeeKey = 'neuro-mock-employee';
const branches = {
  '1': {
    id: '1',
    name: 'First'
  },
  '2': {
    id: '2',
    name: 'Second'
  },
  '3': {
    id: '3',
    name: 'Third'
  },
  '4': {
    id: '4',
    name: 'Fourth'
  },
  '5': {
    id: '5',
    name: 'Fifth'
  },
  '6': {
    id: '6',
    name: 'Sixth'
  },
  '7': {
    id: '7',
    name: 'Seventh'
  },
  '8': {
    id: '8',
    name: 'Eight'
  },
  '9': {
    id: '9',
    name: 'Ninth'
  }
};

const users = {
  'user1': {
    id: 'user1',
    employeeId: 'test123',
    firstName: 'Test',
    lastName: 'User',
    email: 'test@ignitesales.com',
    phone: '2145551234',
    branches: [branches['1'], branches['2']]
  },
  'user2': {
    id: 'user2',
    employeeId: 'jd123',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@ignitesales.com',
    phone: '2143331234',
    branches: [branches['9'], branches['8'], branches['7']]
  },
  'user3': {
    id: 'user3',
    employeeId: 'jane123',
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'jane.doe@ignitesales.com',
    phone: '2148881234',
    branches: [branches['5']]
  }
};

const searchUsers = sv => {
  let result = [];
  if(sv.length >= 3){
    result = Object.values(users).filter(u => u.lastName.includes(sv) || (u.employeeId || '').includes(sv) || u.firstName.includes(sv) || u.email.includes(sv) )
  }
  return result;
};

const searchBranches = sv => {
  let result = [];
  if(sv.length >= 2){
    result = Object.values(branches).filter(b => b.name.toLowerCase().includes(sv.toLowerCase()));
  }
  return result;
};

const MockEmployeeLoginService = {
  get: async (id) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        let user = users[id];
        if (user) {
          resolve(user);
        } else {
          resolve(Object.values(users).find(e => e.employeeId === id));
        }
      }, 1000);
    })
  },

  search: async (value) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        const results = [];
        resolve(searchUsers(value));
      }, 1000);
    });
  },

  searchByThirdPartyId: async (value) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        let result = false;
        resolve(Object.values(users).find(u => u.employeeId === value));
      }, 1000);
    });
  },

  searchByEmail: async (value) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        let result = false;
        resolve(Object.values(users).find(u => u.email === value));
      }, 1000);
    });
  },

  findBranches: async (value) => {
    return new Promise(resolve => {
      window.setTimeout(() => {
        const results = [];
        resolve(searchBranches(value));
      }, 1000);
    });
  },

  getBranch: async (id) => {
    return new Promise(resolve => {
      window.setTimeout(() => {
        resolve(branches[id]);
      }, 1000);
    });
  },

  save: async (employee) => {
    return new Promise(resolve => {
      window.setTimeout(() => {
        console.log('Saving employee', employee);
        if (!employee.id) {
          employee.id = '' + Math.round(Math.random() * 100000);
        }
        users[employee.id] = employee;

        resolve({
          status: 'success',
          employee
        });
      }, 1000);
    });
  },

  login: async ({ employee, branch}) => {
    return new Promise(resolve => {
      window.sessionStorage.setItem( mockEmployeeKey, JSON.stringify({ employee, branch }) );
      window.setTimeout(() => {
        resolve({
          status: 'success',
          employee,
          branch
        });
      }, 1000);
    });
  },

  isLoggedIn: () => {
    const loggedInEmployeeObj = window.sessionStorage.getItem( mockEmployeeKey );
    return loggedInEmployeeObj ? loggedInEmployeeObj : false;
  },

  logout: () => {
    window.sessionStorage.removeItem( mockEmployeeKey );
  }
};

export default MockEmployeeLoginService;
